'use strict';

var CalibrationAnalysisToolbarDirective = function CalibrationAnalysisToolbarDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/calibration-analysis-toolbar.html'),
    controller: 'CalibrationAnalysisToolbarController',
    scope: {
      screenState: '='
    }
  };
};
CalibrationAnalysisToolbarDirective.$inject = [];
module.exports = CalibrationAnalysisToolbarDirective;